module.exports = __webpack_public_path__ + "static/media/close-hamburger.4e9a69d1.svg";